import {
  SERVICE_STAFF_ROLES,
  SERVICE_STAFF_AND_CLIENT_ROLES,
} from "@west-tennessee-consulting/hub-roles";

export const TIME_ENTRY_BILLING_FIELDS = {
billable_rate: {
    type: "number",
    label: "Billable Rate",
    placeholder: "Auto-filled from company (hourly contracts only)",
    formSpan: 1,
    validation: {
      min: 0,
      max: 9999.99,
    },
    // Table properties
    sortable: true,
    filterable: true,
    searchable: false,
    resizable: true,
    hideable: true,
    editable: false, // Still editable for manual override or corrections
    helpText:
      "Automatically populated from company's hourly rate when time entry is created. For monthly contracts, this field is empty (flat monthly fee applies).",
    filterType: "numberRange",
    width: 120,
    minWidth: 100,
    maxWidth: 150,
    icon: "DollarSign",
    // Role-based access control - Financial data restricted to admins and CRM users
    allowedRoles: ["wtc_admin", "wtc_crm"] as string[],
    mobileDetailSectionId: "billing",
  },
is_approved: {
    type: "boolean",
    label: "Approved",
    placeholder: "Mark as approved",
    // Table properties
    sortable: true,
    filterable: true,
    searchable: false,
    resizable: true,
    hideable: true,
    editable: false,
    filterType: "exact",
    width: 100,
    minWidth: 80,
    maxWidth: 120,
    icon: "CheckCircle",
    // Internal approval state — staff only.
    allowedRoles: [...SERVICE_STAFF_ROLES] as string[],
    mobileDetailSectionId: "billing",
  }
} as const;
